import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IHistoricalEvents } from 'src/app/interface/IHistoricalEvents.interface';

@Component({
  selector: 'app-movement-history-table',
  templateUrl: './movement-history-table.component.html',
  styleUrls: ['./movement-history-table.component.scss'],
})
export class MovementHistoryTableComponent implements OnInit, OnChanges {
  @Input() dataSource: IHistoricalEvents[] = [];
  @Input() tabPosition: number = 0;
  displayedColumns: string[] = ['action', 'timestamp'];
  // matDataSource: MatTableDataSource<IHistoricalEvents>;

  constructor() {}

  ngOnInit(): void {
    // this.matDataSource = new MatTableDataSource<IHistoricalEvents>(this.dataSource);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource']) {
      if (changes['dataSource'].previousValue !== changes['dataSource'].currentValue) {
        // this.matDataSource = new MatTableDataSource<IHistoricalEvents>(changes['dataSource'].currentValue);
      }
    }
  }
}
